import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { ServicesCatalogueCarousel } from "../components/ServicesCatalogueCarousel";
import { serviceSagaActions } from "../../Information/Service";
import { DepartmentHeader } from "../components/DepartmentHeader";

import { Form, Col, Card, Container, Row, Spinner, Button } from "react-bootstrap";
import { Search, ArrowBarLeft } from "react-bootstrap-icons";
import { useSubheader } from "../../../../_metronic/layout";

//import "../css/bootstrap-card-columns.css";


export const ServicesCatalogue = (props) => {

  const dispatch = useDispatch();
  const history = useHistory();

  const { 
    serv : { entities: services, totalCount: servicesTotalCount, listLoading },
    catalogue: { selectedDept, selectedProvince } 
  } = useSelector((state) => state);

  const deptId = selectedDept.id;
  const deptName = selectedDept.name;
  const provName = selectedDept.prov_name;
  const provId = selectedProvince.id;

  const subheader = useSubheader();
  subheader.setTitle(deptName);

  useEffect(() => {
    if( deptId === undefined || deptId === null ){
      history.push("/catalogue-management/departments");
    }
  }, [ history, deptId ]);

  const handleBackNavigation = () => {
    history.push("/catalogue-management/departments");
  };

  const debounceFunction = (func, delay) => {
    
    let timer;

    return function() {
      let self = this;
      let args= arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(self, args)
      }, delay)
    }
  };

  //use useCallback to memoized or remeber the original function
  const debounceCatalogueSearch = useCallback(
    debounceFunction(
      (nextValue) => {
        let query = { str: nextValue };
        dispatch(serviceSagaActions.searchServsForDept(deptId, query, provId));
      }, 500
    ), []
  );

  const handleCatalogueSearch = (event) => {
    let nextValue = event.target.value;
    debounceCatalogueSearch(nextValue);
  };

  return (
    <Card>    
      <Card.Header>
        <Row>
          <Col lg={9} sm={12}>
            <DepartmentHeader deptName={deptName} provName={provName} listName={"Agency Service Types"} deptLogo={selectedDept.logo_image} />
          </Col>
          <Col lg={3} sm={12}>
            <Button onClick={handleBackNavigation} style={{float:"right"}} variant="secondary" >
              <ArrowBarLeft size={18} /> {" "} BACK
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container fluid>
          <Row>
            <Col>
              <Form.Group controlId="search">
                <Search size={30} className="pt-3 pl-3" style={{ position: "absolute" }}/>
                <Form.Control
                  className="pl-10"
                  style={{ fontSize: "16px"}}
                  name="search"
                  placeholder="Search for a service"
                  onChange={handleCatalogueSearch}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              { listLoading 
                ? <Spinner className="listSpinner" animation="border" />
                : ( servicesTotalCount <= 0 ? <h5 className="d-flex justify-content-center"> No Services Found </h5> 
                  : <ServicesCatalogueCarousel services={services} deptId={deptId} servicesTotalCount={servicesTotalCount} selectedProvince={selectedProvince} /> )
              }
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};
